import React from "react";
import { Helmet } from "react-helmet";
import "./shared.css";
import "./Tools.css";

function Tools() {
  return (
    <main className="toolsPage">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Tools & Products | Radix Software Solutions</title>
        <meta
          name="description"
          content="Explore Radix Software Solutions tools and products, including CalcStacks for practical, real-world calculators."
        />
        <meta
          property="og:title"
          content="Tools & Products | Radix Software Solutions"
        />
        <meta
          property="og:description"
          content="Explore Radix Software Solutions tools and products, including CalcStacks for practical, real-world calculators."
        />
        <meta property="og:site_name" content="Radix Software Solutions" />
        <meta
          property="og:url"
          content="https://www.radixsoftwaresolutions.com/tools"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Tools & Products | Radix Software Solutions"
        />
        <meta
          name="twitter:description"
          content="Explore Radix Software Solutions tools and products, including CalcStacks for practical, real-world calculators."
        />
        <link
          rel="canonical"
          href="https://www.radixsoftwaresolutions.com/tools"
        />
      </Helmet>

      <section className="section toolsHero">
        <div className="pageContainer">
          <p className="sectionKicker">Tools & Products</p>
          <h1 className="toolsTitle">Tools & Products</h1>
          <p className="paragraphTextStyle toolsIntro">
            Purpose-built tools from Radix Software Solutions that help teams
            make clearer, faster decisions without extra complexity.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="pageContainer">
          <div className="grid toolsGrid">
            <article className="card toolCard">
              <div className="toolHeader">
                <div>
                  <h2 className="cardTitle">CalcStacks</h2>
                  <p className="toolTagline">
                    Practical calculators for real-world decisions.
                  </p>
                </div>
                <span className="toolBadge">Radix Product</span>
              </div>
              <p className="paragraphSnippetStyle toolCopy">
                Practical calculators for real-world decisions - built by Radix
                Software Solutions LLC.
              </p>
              <div className="toolActions">
                <a
                  className="ctaPrimary"
                  href="https://calcstacks.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visit CalcStacks
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Tools;
